<template>
  <main class="view">
    <div class="col col-12 tabs-wrapper">
      <ul :class="['tab-controller', {hidden: !showTabs}]" style="--submenu-bg: #1B577A;">
        <li :class="['tab-controller__item', {active: listsView == 0, '--parent': Check(AdminRoles)}]">
          <router-link class="item-link" :to="{ name: 'picklists'}">{{ $t('Pick lists') }}</router-link>
          <ul class="item-submenu">
            <!--
            <li class="item-submenu__item">
              <router-link class="submenu-link" :to="{ name: 'lists-overview'}"> Overview </router-link>
            </li>
            <li class="item-submenu__item">
              <router-link class="submenu-link" :to="{ name: 'lists-approve'}"> Approve </router-link>
            </li>
            -->
          </ul>
        </li>
        <li v-if="IsMainCompany()" :class="['tab-controller__item', {active: listsView == 1, '--parent': Check(AdminRoles)}]">
          <router-link v-if="IsMainCompany()" class="item-link" :to="{ name: 'collectlists'}">{{ $t('Collect lists') }}</router-link>
          <ul class="item-submenu"></ul>
        </li>
        <li :class="['tab-controller__item', {active: listsView == 2, '--parent': Check(AdminRoles)}]">
          <router-link class="item-link" :to="{ name: 'invoices'}">{{ $t('Bulk invoicing') }}</router-link>
          <ul class="item-submenu"></ul>
        </li>
      </ul>
      <router-view></router-view>
    </div>
  </main>
</template>

<script>
  import { Permissions } from '@/helpers/Permissions';
  import { Config } from '@/helpers/Config';
  import { BPA } from '@/helpers/BPA';

  export default {
    name: 'Lists',
    mixins: [Permissions, Config, BPA],
    data() {
      return {
        dev: Config.dev,
        showTabs: false,
        listsView: 0,
        RouteMapper: {
          picklists: 0,
          collectlists: 1,
          invoices: 2
        },
        AdminRoles: [/*0, 11*/ 'admin', 'list_admin'],
        route: null
      }
    },
    created() {
      this.IsInRouteMapper();
    },
    mounted() {
      this.showTabs = this.tabs.length > 1;
    },
    watch: {
      $route() {
        this.IsInRouteMapper();
      }
    },
    computed: {
      tabs() {
        return document.querySelectorAll('.tab-controller__item');
      }
    },
    methods: {
      IsInRouteMapper() {
        this.route = this.$route.name;
        let name = this.route.split('-')[0];
        if (this.RouteMapper[name] !== null) {
          this.listsView = this.RouteMapper[name];
        }
      },
      Check(required) {
        return BPA.permissions(required).length;
      },
      IsMainCompany() {
        return BPA.util.IsMainCompany();
      }
    }
  }
</script>

<style lang="scss" scoped>
</style>
